import UserSetup from 'main/userSetup/UserSetup'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import StepFinish from 'main/userSetup/steps/StepFinish'

function App(): JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserSetup />} />
        <Route path="/tack" element={<StepFinish />} />
      </Routes>
    </Router>
  )
}

export default App
